<div
  class="quick-access transition flex py-[6px] pr-2 items-center z-[100] fixed bottom-[12dvh] sm:bottom-[50vh] sm:translate-y-[50%] overflow-hidden"
  [ngClass]="{
    'left-0': quickAccessIsOpen,
    'left-[-178px]': !quickAccessIsOpen,
  }"
>
  <div
    id="quick-access-arrow-box"
    class="right-rounded box-shadow transition bg-white relative z-[102] flex flex-col justify-center items-center h-[100px] pl-[2px] cursor-pointer"
    style="width: 30px"
    (click)="toggleQuickAccess()"
  >
    <mat-icon class="!text-primary-main">arrow_right</mat-icon>
  </div>
  <div
    id="quick-access-menu"
    [ngClass]="{'box-shadow': quickAccessIsOpen}"
    class="right-rounded transition bg-white flex flex-col gap-4 items-center relative z-[101] pt-4 pb-6 px-4"
    style="width: 178px"
  >
    <p class="text-primary-main text-[15px] font-bold">دسترسی سریع</p>
    <ul class="flex flex-col gap-2">
      @for (item of items; track item) {
        <ng-template [appHasAccess]="item.role">
          <button
            mat-flat-button
            class="gray-button !h-[34px] !text-secondary-main"
            [routerLink]="item.route"
            (click)="toggleQuickAccess(item.operation)"
          >
            {{ item.key | translate }}
            <mat-icon>{{ item.icon }}</mat-icon>
          </button>
        </ng-template>
      }
    </ul>
  </div>
</div>
